import React from "react";
import { Col, Row, Tab, Tabs, Pagination } from "react-bootstrap";
import { Restaurent } from "../../../../constants/jsonConstant";
import Rating from "@mui/material/Rating";
import { useState, useEffect } from "react";
import "./style.css";
import AvailabilityModel from "../../../servicesProfile/components/Avalibilitymodel";
import Updatefoodform from "../../../Updatefoodform";
import { useNavigate } from "react-router-dom";
import { useGetFoodItemsQuery } from "../../../../features/shop/shopApiSlice";
import Suggestionmodal from "../../../suggestionmodal";
import Suggestion from "../../../suggestion";
import ReportBox from "../../../../components/Reportbox";
import { getAsset } from "../../../../helpers/helper";
import dummyezi from "../../../../assets/images/dummy/dummyezi.png"; // Adjust path as needed

const RestaurantCard = ({
  id,
  suggest,
  suggestdata,
  setSuggest,
  shopData,
  shopid,
}) => {
  const [key, setKey] = useState("home");
  const [itemdata, setItemdata] = useState([]);
  const [saledata, setSaledata] = useState([]);
  const [specialdata, setSpecialdata] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const handleShow = () => setShowavaliable(true);
  const [showavaliable, setShowavaliable] = useState(false);
  const [suggestId, setSuggestId] = useState();
  const navigate = useNavigate();
  localStorage.setItem("suggestid", suggestId);

  const handleSelect = (k) => {
    if (k === "tab1") {
      handleShow();
      setKey("Connents");
    } else if (k === "AddMore") {
      navigate(`/resturent-post-form/${id}`);
    }
  };
  const [Open, setOpen] = useState(false);
  const handleClose = () => setShowavaliable(false);
  const openModal = () => {
    setOpen(true);
  };

  // Generate dummy data
  const generateDummyItem = (index, type) => ({
    _id: `dummy_${type}_${index}`,
    dishname: "Post item to see here",
    preparationTime: "--",
    description: "--",
    images: [dummyezi],
    rating: 0,
    isDummy: true,
  });

  // Initialize state with dummy data
  const minTotalItems = 100;
  const initialDummyItems = Array.from({ length: minTotalItems }, (_, i) =>
    generateDummyItem(i, "regular"),
  );
  const initialDummySales = Array.from({ length: minTotalItems }, (_, i) =>
    generateDummyItem(i, "sales"),
  );
  const initialDummySpecial = Array.from({ length: minTotalItems }, (_, i) =>
    generateDummyItem(i, "special"),
  );

  const {
    data: foodItemsData,
    isLoading: foodItemsLoading,
    isError,
    error,
  } = useGetFoodItemsQuery(id, { 
    skip: !id,
    refetchOnMountOrArgChange: true,
    refetchOnFocus: true
  });

  useEffect(() => {
    if (foodItemsLoading) {
      setIsLoading(true);
      return;
    }

    if (foodItemsData) {
      const regular = foodItemsData?.regular || [];
      const special = foodItemsData?.specialOffers || [];
      const sales = foodItemsData?.salespromotion || [];

      setItemdata([...regular, ...initialDummyItems.slice(regular.length)]);
      setSpecialdata([
        ...special,
        ...initialDummySpecial.slice(special.length),
      ]);
      setSaledata([...sales, ...initialDummySales.slice(sales.length)]);
      setIsLoading(false);
    } else if (isError) {
      setItemdata(initialDummyItems);
      setSpecialdata(initialDummySpecial);
      setSaledata(initialDummySales);
      setIsLoading(false);
    }
  }, [
    foodItemsData,
    foodItemsLoading,
    isError,
    error,
    initialDummyItems,
    initialDummySpecial,
    initialDummySales,
  ]);

  const suggestsingleid = localStorage.getItem("suggestid");

  // Pagination settings
  const itemsPerPage = 50;

  // Regular Items Pagination
  const [currentPageRegular, setCurrentPageRegular] = useState(1);
  const totalItemsRegular = Math.max(itemdata.length, minTotalItems);
  const totalPagesRegular = Math.ceil(totalItemsRegular / itemsPerPage);
  const startIndexRegular = (currentPageRegular - 1) * itemsPerPage;
  const currentItemsRegular = itemdata.slice(
    startIndexRegular,
    startIndexRegular + itemsPerPage,
  );

  // Sales Promotion Pagination
  const [currentPageSales, setCurrentPageSales] = useState(1);
  const totalItemsSales = Math.max(saledata.length, minTotalItems);
  const totalPagesSales = Math.ceil(totalItemsSales / itemsPerPage);
  const startIndexSales = (currentPageSales - 1) * itemsPerPage;
  const currentItemsSales = saledata.slice(
    startIndexSales,
    startIndexSales + itemsPerPage,
  );

  // Special Offers Pagination
  const [currentPageSpecial, setCurrentPageSpecial] = useState(1);
  const totalItemsSpecial = Math.max(specialdata.length, minTotalItems);
  const totalPagesSpecial = Math.ceil(totalItemsSpecial / itemsPerPage);
  const startIndexSpecial = (currentPageSpecial - 1) * itemsPerPage;
  const currentItemsSpecial = specialdata.slice(
    startIndexSpecial,
    startIndexSpecial + itemsPerPage,
  );

  const handlePageChangeRegular = (pageNumber) => {
    setCurrentPageRegular(pageNumber);
    window.scrollTo(0, 0);
  };

  const handlePageChangeSales = (pageNumber) => {
    setCurrentPageSales(pageNumber);
    window.scrollTo(0, 0);
  };

  const handlePageChangeSpecial = (pageNumber) => {
    setCurrentPageSpecial(pageNumber);
    window.scrollTo(0, 0);
  };

  const renderItem = (box, isSales = false, isSpecial = false) => (
    <Row
      key={box._id}
      className="restaurant-food-card mt-2 border_3 p-2 m-0 align-items-center rounded bg-white"
      style={{
        minHeight: "120px",
        boxShadow: "0px 0px 5px 1px rgba(0, 0, 0, 0.2)",
      }}
    >
      <Col xs={4} md={3} className="restaurant-food-image-col p-0">
        <div className="position-relative imagesetttttt">
          {isSales && (
            <div className="salestwo ps-2 pe-2">{box?.salesPromotion}</div>
          )}
          {isSpecial && (
            <div className="sales ps-2 pe-2">{box?.specialOffers}</div>
          )}
          <img
            className="food-img"
            src={
              box.isDummy
                ? dummyezi
                : box.images?.[0]
                  ? getAsset(box.images[0])
                  : dummyezi
            }
            alt={box.dishname || "Food Item"}
            style={{ objectFit: "cover", maxHeight: "150px", width: "100%" }}
            loading="lazy"
            crossOrigin="anonymous"
          />
        </div>
      </Col>
      <Col xs={8} md={9} className="restaurant-food-info p-0">
        <div className="d-flex flex-column justify-content-center h-100">
          <div className="restaurant-food-card-heading">
            <div className="restaurant-food-title mt-3">
              <h6 className="mb-1">{box.dishname}</h6>
            </div>
            <div className="restaurant-food-preparation text-center mt-3">
              <h6 className="mb-1">
                Preparation Time: {box.preparationTime} Min
              </h6>
            </div>

            <div className="restaurant-food-rating mt-3 d-flex justify-content-end">
              <h6>Rating</h6>&nbsp;
              <Rating
                name="read-only"
                readOnly
                value={box.rating || 0}
                size="small"
              />
            </div>
          </div>
          <div className="restaurant-food-description">
            <div>
              <h6 className="mb-1">Description</h6>
              <p className="mb-1 font_14">{box.description}</p>
            </div>
          </div>
          <div className="restaurant-food-view mt-3">
            <h6 className="mb-1">
              <button
                className="viewshopnew"
                onClick={() => navigate(`/food-item-view/${id}/${box._id}`)}
                style={{
                  background: "#0353a4",
                  color: "white",
                  fontSize: "11px",
                  borderRadius: "50px",
                }}
              >
                View
              </button>
            </h6>
          </div>
        </div>
      </Col>
    </Row>
  );

  return (
    <>
      <AvailabilityModel
        handleClose={handleClose}
        showavaliable={showavaliable}
        setShowavaliable={setShowavaliable}
      />

      {Open && <Updatefoodform setOpen={setOpen} Open={Open} />}

      <Col lg="12" className="mt-4">
        {suggest === 1 ? (
          <Suggestionmodal
            setSuggestId={setSuggestId}
            setSuggest={setSuggest}
            suggest={suggest}
            suggestdata={suggestdata}
            shopid={shopid}
            shopData={shopData}
          />
        ) : suggest === 2 ? (
          <ReportBox setSuggest={setSuggest} suggest={suggest} />
        ) : suggest === 3 ? (
          <Suggestion
            suggestsingleid={suggestsingleid}
            suggestdata={suggestdata}
            shopData={shopData?.shopid}
            setSuggest={setSuggest}
            shopid={shopData?.shopid}
          />
        ) : (
          <Tabs
            id="controlled-tab-example"
            activeKey={key}
            onSelect={(k) => {
              setKey(k);
              handleSelect(k);
            }}
            className="mb-3 ms-1 adddmoree groundset"
          >
            <Tab
              eventKey="home"
              title="Regular Items"
              className="resturent-height noscroll"
            >
              {isLoading ? (
                <div className="text-center">Loading...</div>
              ) : (
                <>
                  {currentItemsRegular.map((box) => renderItem(box))}
                  {totalPagesRegular > 1 && (
                    <div className="d-flex justify-content-center mt-4">
                      <Pagination>
                        <Pagination.Prev
                          onClick={() =>
                            handlePageChangeRegular(currentPageRegular - 1)
                          }
                          disabled={currentPageRegular === 1}
                        />
                        {Array.from(
                          { length: totalPagesRegular },
                          (_, index) => (
                            <Pagination.Item
                              key={index + 1}
                              active={index + 1 === currentPageRegular}
                              onClick={() => handlePageChangeRegular(index + 1)}
                            >
                              {index + 1}
                            </Pagination.Item>
                          ),
                        )}
                        <Pagination.Next
                          onClick={() =>
                            handlePageChangeRegular(currentPageRegular + 1)
                          }
                          disabled={currentPageRegular === totalPagesRegular}
                        />
                      </Pagination>
                    </div>
                  )}
                </>
              )}
            </Tab>

            <Tab
              eventKey="saleitems"
              title="Sales Promotion"
              className="resturent-height noscroll"
            >
              {isLoading ? (
                <div className="text-center">Loading...</div>
              ) : (
                <>
                  {currentItemsSales.map((box) => renderItem(box, true))}
                  {totalPagesSales > 1 && (
                    <div className="d-flex justify-content-center mt-4">
                      <Pagination>
                        <Pagination.Prev
                          onClick={() =>
                            handlePageChangeSales(currentPageSales - 1)
                          }
                          disabled={currentPageSales === 1}
                        />
                        {Array.from({ length: totalPagesSales }, (_, index) => (
                          <Pagination.Item
                            key={index + 1}
                            active={index + 1 === currentPageSales}
                            onClick={() => handlePageChangeSales(index + 1)}
                          >
                            {index + 1}
                          </Pagination.Item>
                        ))}
                        <Pagination.Next
                          onClick={() =>
                            handlePageChangeSales(currentPageSales + 1)
                          }
                          disabled={currentPageSales === totalPagesSales}
                        />
                      </Pagination>
                    </div>
                  )}
                </>
              )}
            </Tab>

            <Tab
              eventKey="specialitems"
              title="Special Offers"
              className="resturent-height noscroll"
            >
              {isLoading ? (
                <div className="text-center">Loading...</div>
              ) : (
                <>
                  {currentItemsSpecial.map((box) =>
                    renderItem(box, false, true),
                  )}
                  {totalPagesSpecial > 1 && (
                    <div className="d-flex justify-content-center mt-4">
                      <Pagination>
                        <Pagination.Prev
                          onClick={() =>
                            handlePageChangeSpecial(currentPageSpecial - 1)
                          }
                          disabled={currentPageSpecial === 1}
                        />
                        {Array.from(
                          { length: totalPagesSpecial },
                          (_, index) => (
                            <Pagination.Item
                              key={index + 1}
                              active={index + 1 === currentPageSpecial}
                              onClick={() => handlePageChangeSpecial(index + 1)}
                            >
                              {index + 1}
                            </Pagination.Item>
                          ),
                        )}
                        <Pagination.Next
                          onClick={() =>
                            handlePageChangeSpecial(currentPageSpecial + 1)
                          }
                          disabled={currentPageSpecial === totalPagesSpecial}
                        />
                      </Pagination>
                    </div>
                  )}
                </>
              )}
            </Tab>
            <Tab
              eventKey="AddMore"
              title="&#10133; Add More"
              className="resturent-height noscroll"
              onSelect={(k) => handleSelect(k)}
            ></Tab>
          </Tabs>
        )}
      </Col>
    </>
  );
};

export default RestaurantCard;
